import { useTranslation } from "react-i18next";
import { AgreementFields, AgreementDataRow } from "../shared/AgreementDataRow";
import { FileMetadata } from "../../utils";

interface AgreementDataSectionProps {
  title: string;
  fields: AgreementFields;
  draftData: Record<string, unknown>;
  confirmedData: Record<string, unknown>;
  translationPrefix: string;
  attachments?: Record<string, FileMetadata[]>;
}

export const AgreementDataSection = ({
  title,
  fields,
  draftData,
  confirmedData,
  translationPrefix,
  attachments,
}: AgreementDataSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      {title}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="w-1/4 pb-1.5 border-b-2 border-gray-300 text-left">
                <h3 className="text-xs font-bold text-gray-800 uppercase tracking-wide">
                  {t("agreements.common.draftData")}
                </h3>
              </th>
              <th className="w-1/4 pb-1.5 border-b-2 border-gray-300 text-left">
                <h3 className="text-xs font-bold text-gray-800 uppercase tracking-wide opacity-0">
                  -
                </h3>
              </th>
              <th className="w-1/4 pb-1.5 border-b-2 border-gray-300 text-left">
                <h3 className="text-xs font-bold text-gray-800 uppercase tracking-wide">
                  {t("agreements.common.confirmedData")}
                </h3>
              </th>
              <th className="w-1/4 pb-1.5 border-b-2 border-gray-300 text-left">
                <h3 className="text-xs font-bold text-gray-800 uppercase tracking-wide opacity-0">
                  -
                </h3>
              </th>
            </tr>
          </thead>
          <tbody className="space-y-1.5">
            {fields.map((field) => (
              <AgreementDataRow
                key={field.key}
                field={field}
                draftValue={draftData?.[field.key]}
                confirmedValue={confirmedData?.[field.key]}
                translationPrefix={translationPrefix}
                attachments={attachments}
                draftData={draftData}
                confirmedData={confirmedData}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
